var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectInsight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 42,
    viewBox: "0 0 46 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1,
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 22v3c0 1.105-.895 2-2 2h-4c-1.105 0-2-.895-2-2v-3M14 0L14 2M0 14L2 14M3 4L4.467 5.409M28 14L26 14M25 4L23.533 5.409M9.887 22h8.226c3.032-1.505 4.932-4.615 4.887-8-.088-4.934-4.066-8.912-9-9-4.936.088-8.915 4.07-9 9.005-.043 3.383 1.857 6.49 4.887 7.995h0zM14 27L14 30M14 17L14 22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 14L14 17 17 14"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectInsight);
export default __webpack_public_path__ + "static/media/project-insight.1672c05dc5016b99b55b42bdf1433700.svg";
export { ForwardRef as ReactComponent };